import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '主用例',
    type: 'SF_MAIN',
}
